import { c as _c } from "react/compiler-runtime";
import { CalendarIcon, Text, Tooltip } from "@flat-ui";
import { useDateTime } from "@hooks/use-date-time";
import { Stack } from "@mui-wrapper";
import { DUE_DATE_URGENCY_TOOLTIPS } from "@pages/project-details/project-markups/board/markups-board-due-date-chip";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Colors of the due date for each urgency, matching the due soon and overdue KPIs */
const DUE_DATE_COLORS = {
  none: {
    icon: PALETTE_VARS.text.secondary,
    text: PALETTE_VARS.text.secondary
  },
  // The warning color is too light for text, so only the icon carries it
  dueSoon: {
    icon: PALETTE_VARS.warning.main,
    text: PALETTE_VARS.text.primary
  },
  overdue: {
    icon: PALETTE_VARS.error.main,
    text: PALETTE_VARS.error.main
  }
};
/** Due date of a markup as text with a calendar icon, colored when it is due soon or overdue */
export function MarkupDueDateText(t0) {
  const $ = _c(15);
  const {
    markup,
    urgency
  } = t0;
  const {
    formatDate
  } = useDateTime();
  if (!markup.dueDate) {
    return null;
  }
  const colors = DUE_DATE_COLORS[urgency];
  const t1 = DUE_DATE_URGENCY_TOOLTIPS[urgency];
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center",
      gap: 0.5,
      flexShrink: 0
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== colors.icon) {
    t3 = <CalendarIcon sx={{
      width: "1rem",
      height: "1rem",
      color: colors.icon
    }} />;
    $[1] = colors.icon;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = colors.text;
  let t5;
  if ($[3] !== formatDate || $[4] !== markup.dueDate.value) {
    t5 = formatDate(markup.dueDate.value);
    $[3] = formatDate;
    $[4] = markup.dueDate.value;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== colors.text || $[7] !== t5) {
    t6 = <Text variant="bodyS" component="var" color={t4}>{t5}</Text>;
    $[6] = colors.text;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t6) {
    t7 = <Stack direction="row" sx={t2}>{t3}{t6}</Stack>;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t1 || $[13] !== t7) {
    t8 = <Tooltip title={t1}>{t7}</Tooltip>;
    $[12] = t1;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}